export default {
  PersonalWheelchairAssistanceFormFields__DISCLAIMER:
    "Wheelchairs and devices exceeding 500 pounds or a height that exceeds 45 inches or a width or depth that exceeds 34 inches will not be accepted for travel.",
  PersonalWheelchairAssistanceFormFields__HEADER: "Personal wheelchair stowage",
  PersonalWheelchairAssistanceFormFields__MANUAL_WHEELCHAIR: "Manual wheelchair",
  PersonalWheelchairAssistanceFormFields__NOTE: "Note:",
  PersonalWheelchairAssistanceFormFields__NO_WHEELCHAIR_STOWAGE: "No wheelchair stowage needed",
  PersonalWheelchairAssistanceFormFields__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.name} option selected. ${data.index} of ${data.length}`,
  PersonalWheelchairAssistanceFormFields__WHEELCHAIR_BATTERIES_COUNT_TEXT: "How many batteries?",
  PersonalWheelchairAssistanceFormFields__WHEELCHAIR_WITH_NON_SPILLABLE_BATTERIES:
    "Powered wheelchair with non-spillable batteries",
  PersonalWheelchairAssistanceFormFields__WHEELCHAIR_WITH_SPILLABLE_BATTERIES:
    "Powered wheelchair with spillable batteries",
  PersonalWheelchairAssistanceFormFields__WITH_REMOVABLE_BATTERIES:
    "Powered wheelchair with 300-watt removable lithium-ion batteries",
};
